import React, { useContext } from 'react';
import { getAppEnv } from '../../../../config/env';
import { EnvironmentVariables } from '../../../types';
import { decorateLocation } from './LocationInputSection';
import { cabsLandingWidgetInfo } from '../../../cabsLandingWidgetInfo';
import {
  CabsLandingContext,
  CabsLandingDispatchContext
} from '../../../CabsLandingContext';
import { getPlaceObject } from '../../../utils/reverseGeoCode';
import { CityLocation } from '../../runtime-typechecker';
import {
  SET_STOPOVERS,
  SET_WIDGET,
  SET_ACTIVE_STOPOVER
} from '../cabsLandingPageState';
import { OUTSTATION_ONE_WAY } from '../../../constants/tripTypes';
import {
  MOB_CABS_LANDING_OW_CLOSE_STOP_CLICK,
  MOB_CABS_LANDING_RT_CLOSE_STOP_CLICK
} from '../../../constants/omnitureConstants';
const env = getAppEnv();
const { DATA_LOADER_URL } = env.raw as EnvironmentVariables;
const { PUBLIC_URL } = env.raw;

export const StopOverInput = ({
  stopOverId,
  cityLocation,
  widgetComponent
}) => {
  const cabsLandingContext = useContext(CabsLandingContext);
  const dispatch = useContext(CabsLandingDispatchContext);

  const {
    stopOvers,
    activeStopOver,
    widget,
    travelFor,
    trackTemplateEvent
  } = cabsLandingContext;
  const setStopOvers = stopOvers => {
    dispatch && dispatch({ type: SET_STOPOVERS, newStateValue: stopOvers });
  };

  const setWidget = widgetNumber => {
    dispatch && dispatch({ type: SET_WIDGET, newStateValue: widgetNumber });
  };
  const setActiveStopOver = activeStopOver => {
    dispatch &&
      dispatch({ type: SET_ACTIVE_STOPOVER, newStateValue: activeStopOver });
  };

  const onStopOverDelete = deletingIdx => {
    if (travelFor === OUTSTATION_ONE_WAY)
      trackTemplateEvent(MOB_CABS_LANDING_OW_CLOSE_STOP_CLICK);
    else trackTemplateEvent(MOB_CABS_LANDING_RT_CLOSE_STOP_CLICK);
    const newStopOvers = stopOvers.filter((_, idx) => idx !== deletingIdx);
    setStopOvers(newStopOvers);
  };

  return (
    <div id={`stopOver_${stopOverId}`} className="stopOver">
      <div
        style={{
          backgroundColor: 'rgb(247, 247, 247)',
          border: '1px solid rgb(231, 231, 231)',
          marginTop: '10px'
        }}
        className="cabsLandingRsw fullWidth makeFlex rsw"
      >
        <div
          style={{ width: '87%' }}
          onClick={() => {
            setActiveStopOver(stopOverId);
            setWidget(cabsLandingWidgetInfo.STOPOVER_CITY_LOCATION_WIDGET);
          }}
        >
          <div className="fullWidth makeFlex alignCenter">
            <img
              className="appendRight10"
              src={`${PUBLIC_URL}/static/public/to.webp`}
              height={'24px'}
              width={'24px'}
              alt="logo"
            />
            <div className="fullWidth">
              {cityLocation != null && cityLocation.city !== '' ? (
                <div
                  style={{ color: 'rgb(155, 155, 155)' }}
                  className="latoBold font11"
                >
                  {`STOP ${stopOverId + 1}`}
                </div>
              ) : null}

              {cityLocation === null || cityLocation.city === '' ? (
                <div
                  style={{ color: 'rgb(155, 155, 155)' }}
                  className="latoBold font14"
                >{`STOP ${stopOverId + 1}`}</div>
              ) : (
                <div className="fullWidth">
                  {decorateLocation(cityLocation)}
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            width: '13%',
            zIndex: 6,
            position: 'relative',
            right: '10px'
          }}
          className="vertlCenter"
          onClick={() => onStopOverDelete(stopOverId)}
        >
          <div
            className="makeFlex"
            style={{
              marginLeft: 'auto',
              opacity: '.5',
              backgroundColor: 'rgb(231, 231, 231)',
              borderRadius: '100px',
              height: '18px',
              width: '18px'
            }}
          >
            <img
              className="appendRight10"
              src={`${PUBLIC_URL}/static/public/cross.webp`}
              alt="cross"
            />
          </div>
        </div>
        {widget == cabsLandingWidgetInfo.STOPOVER_CITY_LOCATION_WIDGET &&
          stopOverId === activeStopOver &&
          widgetComponent}
      </div>
    </div>
  );
};
